<template>
  <div class="timeline-section">
    <div
      class="timeline-section__edge d-flex flex-direction-column align-center"
    >
      <div class="line"></div>
    </div>

    <h2 class="pt-1 pb-1 mb-0 text-center">
      {{ section.label }}
    </h2>

    <div ref="products" class="timeline-section__products p-relative w-100">
      <svg
        width="2"
        :height="h"
        :viewBox="`0 0 2 ${h}`"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="timeline__line"
      >
        <path
          d="M1 1L1 2"
          stroke="#002E5D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="2 9"
        />

        <path
          :d="`M1 11L1 ${h}`"
          stroke="#002E5D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="2 9"
        />
      </svg>
      <timeline-section-child
        v-for="product in section.products"
        :key="product.uid"
        :product="product"
        class="mb-3 md-md-0"
      />
    </div>
  </div>
</template>

<script>
import TimelineSectionChild from './sectionChild'

export default {
  name: 'TimelineSection',
  components: {
    TimelineSectionChild,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    h: 0,
  }),
  mounted() {
    this.h = this.$refs.products?.clientHeight || 0

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.h = this.$refs.products?.clientHeight || 0
    },
  },
}
</script>

<style lang="scss">
.timeline-section {
  position: relative;
  overflow: hidden;

  &__products {
    padding: rem(38px) 0;
  }

  .timeline__line {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &:last-child {
    .timeline-section__products {
      padding-bottom: 0;
    }

    .timeline__child:last-child {
      &::after {
        content: '';
        position: absolute;
        width: rem(3px);
        top: calc(var(--spacing) * 0.6);
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: var(--tertiary-color);
      }
    }
  }

  + .timeline-section {
    .timeline-section__edge {
      display: none;
    }
  }
}
</style>
